
<template>
  <component
    :is="'div'"
    :class="['fuzzy-search']"
  >
    
    <auto-complete 
      placeHolder="Search for anything"
      @onTyped="triggerSearch"
      :loading="loading"
    ></auto-complete>

        <base-dropdown 
            v-if="options.length > 0"
            :isOpenDefault=true
            :hasToggle=false
            v-on:change="onDropDownChange"
        >
          <router-link class="dropdown-item" :key="option.record.id" v-for="option in options" :to="{ name: option.type, params: { id: option.record.id }}">
            <badge pill :type="getPillColorFromType(option.type)">{{option.type}}</badge> 
            {{option.record.label}}
          </router-link>
        </base-dropdown>

  </component>
</template>
<script>

import api from '@/api'

export default {
  name: 'fuzzy-search',
  props: {
    
  },
  data() {
    return {
        loading: false,
        options: []
    };
  },
  methods: {
    onDropDownChange: function(isOpen) {
      if(!isOpen) {
        this.options = [];
      }
    },
    triggerSearch: function(value) {
      this.options = [];
      if(value.length > 2) {
        this.fetchResults(value);
        this.loading = true;
      }
    },
    fetchResults: async function(value) {
        const results = await api.search(value)
        this.options = results;
        this.loading = false;
    },
    getPillColorFromType: function(type) {
        switch(type) {
            case 'group':
                return `info`;
            case 'user':
                return `success`;
        }
    }
  }
}
</script>